module.exports = "/fonts/fa-solid-900.woff?3a5706fab1c11ad6dfdc7d0fc33cc238";